import React, { useState } from 'react';
import axios from 'axios';
import STTDescription from "./STT_description";

const TranscriptionPage = () => {
  const [file, setFile] = useState(null);
  const [language, setLanguage] = useState("en");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [segments, setSegments] = useState("");
  const [jobId, setJobId] = useState(null);
  const [polling, setPolling] = useState(false);
  
  const [sendEmail, setSendEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");

  const isValidEmail = (v) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const fileSizeInBytes = selectedFile.size;
    const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(2);
    console.log(`File size: ${fileSizeInMB} MB`);

    if (fileSizeInBytes > 100 * 1024 * 1024) {
      alert("File too large!");
      return;
    }

    const fileType = selectedFile.type;
    const validTypes = ['audio/', 'video/'];
    const isValid = validTypes.some(type => fileType.startsWith(type));

    if (!isValid) {
      alert(`Unsupported file type: ${fileType}. Please upload an audio or video file`);
      e.target.value = null;
      return;
    }

    setFile(selectedFile);
    setResult("");
    setSegments([]);
    setJobId(null);
  };


  
  async function getSignURLAndUpload(file: File, language) {
	console.log("File Name = "+file.name);
	console.log("File Type	= "+file.type);
	console.log("File Size = "+file.size);
	console.log("Lang = "+language);
	
	const formData = new FormData();
    formData.append("fileName", file.name);
    formData.append("fileType", file.type);
    formData.append("fileSize", file.size);
	formData.append("lang", language);
	
    // 1) Ask backend for a short-lived signed URL
	const url = "https://sttapi.pscribes.com/getUploadUrl";
	
    //const { data } = await axios.post(url, formData);
	const rsp = await axios.post(url, formData);
	const data = rsp.data;
	
	if (rsp.data === "FAILED" ) {
      return 0;
	}
		
	console.log("Data : "+rsp.data);
	console.log("Signed URL = " +data.uploadUrl);
	console.log("job Id = " +data.jobId)
	console.log("blob_name = "+data.blob_name);
	console.log("Filename = "+file.name)

    // 2) PUT the file straight to GCS with that URL
    await axios.put(data.uploadUrl, file, {
      headers: { "Content-Type": file.type || "application/octet-stream" },
      onUploadProgress: (e) => {
        if (e.total) {
          const pct = Math.round((e.loaded * 100) / e.total);
          console.log(`Uploading… ${pct}%`);
        }
      },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });

    console.log("Uploading Finished.")
	
	const jobFormData = new FormData();
	jobFormData.append("jobId", data.jobId);
	jobFormData.append("language", language);
	jobFormData.append("filename", file.name);
	jobFormData.append("blob_name", data.blob_name);
	
	
	// 3) Upload done. Call backend with required parameters
	const backUrl = "https://sttapi.pscribes.com/transcribe";
	const resp = await axios.post(backUrl, jobFormData);
	
	console.log("Resp : " +resp.data)
	console.log("Job Id : " +resp.data.jobId)


    return resp.data.jobId;
  }




  const handleUpload = async () => {
    if (!file) return alert("Please select a file first.");
	
	if (sendEmail) {
      if (!email || !isValidEmail(email)) {
        setEmailErr("Please enter a valid email address.");
        return;
      }
    }
	
    setLoading(true);
    setResult("");
    setSegments("");
    setJobId(null);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("language", language);
    formData.append("user_agent", navigator.userAgent);
	formData.append("send_email", String(sendEmail));   // "true" / "false"
    if (sendEmail) formData.append("email", email);
	
    try {
		
	  const jobId = await getSignURLAndUpload(file, language);
	  
	  if (jobId === 0) {
		alert("Something went wrong during transcription. Please try again.");
		return;

      }		  
      console.log("Job ID : " +jobId)
	  
	  setJobId(jobId);
      setPolling(true);
      pollTranscriptionStatus(jobId);
		
	} catch (err) {
	  alert("Something went wrong during transcription. " + err);
    } finally {
      setLoading(false);
    }
  };

  const pollTranscriptionStatus = async (jobId) => {
    const interval = setInterval(async () => {
      try {
		const url = "https://sttapi.pscribes.com/gettranscription";
        const res = await axios.get(url, { params: { jobId } });
        if (res.data.status === "success") {
          clearInterval(interval);
          setResult(res.data.transcription);
		  setSegments(res.data.segments);
          setPolling(false);
        } else if (res.data.status === "failed") {
          clearInterval(interval);
          setPolling(false);
          alert("Transcription failed: " + res.data.error);
        }
      } catch (err) {
        clearInterval(interval);
        setPolling(false);
        alert("Polling error: " + err.message);
      }
    }, 10000);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(result);
    alert("Transcription copied!");
  };
  
  const Spinner = () => (
    <div className="flex justify-center items-center mt-4">
      <div className="w-8 h-8 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
    </div>
  );


  const handleDownload = (type) => {
    let content = "";
    let filename = "";

    if (type === 'txt') {
      content = result;
      filename = "transcription.txt";
    } else if (type === 'srt') {
		content = segments;
      filename = "transcription.srt";
    }

    const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    setShowDownloadMenu(false);
  };

  return (
    <div className="flex flex-col items-center justify-center px-4 py-8 text-center">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-600 leading-tight mb-3 text-center">
        Audio to Text AI Converter Online
      </h1>

      <p className="text-gray-600 text-lg mb-6 font-medium">
        Transcribe your audio into accurate text with our AI-powered tool.
      </p>

      <div className="mt-10">
        <label htmlFor="file-upload" className="cursor-pointer bg-blue-400 text-white font-bold py-3 px-6 rounded-lg shadow-md hover:bg-blue-500 flex items-center space-x-2">
          <span className="text-white">➕</span>
          <span>Choose file</span>
        </label>
        <input id="file-upload" type="file" className="hidden" onChange={handleFileChange} />
      </div>

      {file && (
        <>
          <p className="mt-4 mb-4 font-medium text-green-700">Selected: {file.name}</p>

          <select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            className="mb-4 p-2 rounded-md border w-60"
          >
            <option value="en">English</option>
            <option value="fr">French</option>
            <option value="zh">Chinese</option>
            <option value="de">German</option>
            <option value="ru">Russian</option>
            <option value="es">Spanish</option>
            <option value="hi">Hindi</option>
            <option value="ar">Arabic</option>
            <option value="pt">Portuguese</option>
            <option value="ja">Japanese</option>
            <option value="ko">Korean</option>
            <option value="tr">Turkish</option>
            <option value="it">Italian</option>
            <option value="nl">Dutch</option>
            <option value="vi">Vietnamese</option>
          </select>

          {!polling && (	
		  
		    <>
            <label className="flex items-center gap-2 my-3 select-none">
			
            <input
              type="checkbox"
              className="h-4 w-4 accent-blue-600"
              checked={sendEmail}
              onChange={(e) => {
                setSendEmail(e.target.checked);
                if (!e.target.checked) setEmailErr(""); // clear errors when unchecked
              }}
            />
            <span className="text-gray-700">Email me the transcription</span>
            </label>

            {sendEmail && (
              <div className="w-full max-w-md mx-auto text-left">
              <p className="text-[clamp(0.85rem,1.5vw,1rem)] text-gray-600 mb-[clamp(0.75rem,1.5vw,1rem)]">
               Enter your email address & we’ll send the transcription to you.
              </p>

              <input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (emailErr) setEmailErr("");
                }}
                placeholder="Email"
                className="border border-[#A0A0A080]/50 placeholder:text-[#333] rounded-lg
                 p-[clamp(0.6rem,1.2vw,1rem)] w-full text-[clamp(0.9rem,1.2vw,1rem)] mb-4"
              />
              {emailErr && <div className="text-red-600 text-sm mt-1">{emailErr}</div>}
              </div>
            )}

		    <button
              onClick={handleUpload}
              disabled={loading || !file || (sendEmail && !isValidEmail(email))}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg mb-4"
            >
              {loading ? "Uploading..." : "Transcribe"}
            </button>
			
			</>
		  )}

          {polling && (
            <div className="flex flex-col items-center mt-4 space-y-2">
              <Spinner />
              <p className="text-blue-600 font-medium">Transcription in progress... Please wait.</p>
            </div>
          )}
        </>
      )}

      {result && (
        <div className="space-y-3 w-full max-w-2xl">
          <div className="flex gap-2 justify-end">
            <button
              onClick={handleCopy}
              className="bg-white border px-4 py-2 rounded-md text-sm hover:bg-gray-100"
            >
              Copy
            </button>

            <div className="relative">
              <button
                onClick={() => setShowDownloadMenu(!showDownloadMenu)}
                className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700"
              >
                Download ▼
              </button>

              {showDownloadMenu && (
                <div className="absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white border">
                  <button
                    onClick={() => handleDownload('txt')}
                    className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                  >
                    Text (TXT)
                  </button>
                  <button
                    onClick={() => handleDownload('srt')}
                    className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                  >
                    Subtitles (SRT)
                  </button>
                </div>
              )}
            </div>
          </div>
          <pre className="bg-white p-4 rounded-lg shadow-md whitespace-pre-wrap break-words max-h-96 overflow-y-auto">{result}</pre>
        </div>
      )}
	  
	  <div className="mt-10 text-left">
        <STTDescription />
      </div>
		
    </div>
  );
};

export default TranscriptionPage;
